export default __webpack_public_path__ + "static/media/stranger.b3d254b8.png";